module.exports = __webpack_public_path__ + "img/logo-chile-creativo-73x56.af55823c.png";